import { provideWidgetClass } from "scrivito";

export const SchemaWidget = provideWidgetClass("SchemaWidget", {
  attributes: {
    type: [
      "enum",
      {
        values: [
          "CollegeOrUniversity",
          "ContactPoint",
          "EducationalOccupationalProgram",
          "EducationalOrganization",
          "Event",
          "JobPosting",
          "Person",
          "PostalAddress",
          "Product",
          "Book",
          "CreativeWork",
          "Review",
        ],
      },
    ],

    name: "string",
    description: "string",
    eventType: ["enum", { values: ["Place", "VirtualLocation"] }],
    eventSubtype: ["enum", { values: ["Event", "EducationEvent"] }],
    areaServed: "string",
    availableLanguage: "stringlist",
    contactType: "string",
    email: "string",
    hoursAvailable: "string",
    telephone: "string",

    date: "datetime",
    endDate: "datetime",
    organizerName: "string",

    jobTitle: "string",
    datePosted: "date",
    employmentType: [
      "enum",
      {
        values: [
          "FULL_TIME",
          "PART_TIME",
          "CONTRACTOR",
          "TEMPORARY",
          "INTERN",
          "VOLUNTEER",
          "PER_DIEM",
          "OTHER",
        ],
      },
    ],
    employmentTypeOther: "string",
    organizationName: "string",
    baseSalary: "integer",
    validThrough: "date",

    url: "string",
    logo: ["reference", { only: "Image" }],
    locationName: "string",
    locationDescription: "string",
    addressCountry: "string",
    addressLocality: "string",
    addressRegion: "string",
    postOfficeBoxNumber: "string",
    postalCode: "string",
    streetAddress: "string",
    locationUrl: "string",

    familyName: "string",
    givenName: "string",
    honorificPrefix: "string",

    brandName: "string",
    sellerName: "string",
    review: "string",

    isbn: "string",
    price: "integer",
    priceCurrency: "string",
    report: "string",
    techArticle: "string",
    accessMode: "string",
    bookFormat: "string",
    datePublished: "date",

    reviewBody: "string",
    ratingValue: "string",
    authorName: "string",

    itemName: "string",
    itemDescription: "string",

    educationalCredentialAwarded: "string",
    numberOfCredits: "integer",
    timeToComplete: "string",
    applicationDeadline: "date",
    programPrerequisites: "string",
  },
});

export type SchemaWidgetInstance = InstanceType<typeof SchemaWidget>;
